// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./result-list/components/competitor-result/styles.scss
// module id = 953
// module chunks = 0